// extracted by mini-css-extract-plugin
module.exports = {"veileder":"Veileder_veileder__yoSC1","centerContent":"Veileder_centerContent__5h3rM","noBorder":"Veileder_noBorder__WAOdV"};